import {getUnderwritingQuestions} from 'ApplicationEntry/api/awdApi';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import * as UW from 'ApplicationEntry/ducks/underwritingQuestions';
import {question} from 'ApplicationEntry/models/UWQuestionsModel';
import {push} from 'connected-react-router';
import {AsyncResult, Loaded} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import * as I from 'immutable';
import {all, call, put, takeLatest} from 'redux-saga/effects';

function* getQuestionList() {
  yield takeLatest(UW.UWQuestionsActionType.GET_QUESTIONS, function*(action: ReturnType<typeof UW.getQuestionList>) {
    const response: AsyncResult<{documentQuestions: question[]}> = yield call(
      getUnderwritingQuestions,
      action.payload.formNumber
    );
    if (E.isRight(response)) {
      let answers = I.List<boolean | string>();
      let responseList = I.List<question>();
      response.right.documentQuestions.forEach(questions => {
        const existing = responseList;
        const newList = existing.concat(questions);
        responseList = newList;

        const existingAnsList = answers;
        const newAnsList = existingAnsList.concat('');
        answers = newAnsList;
      });

      yield put(UW.changeQuestions(new Loaded(responseList)));
      yield put(UW.changeMultAnswers(answers));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(UW.changeQuestions(response.left));
    }
  });
}

export default function*() {
  yield all([getQuestionList()]);
}
